import { API } from "../../../utils/api";

export const getBatchGroupList = async () => {
  const res = await API.get(`batchgroup-list`);
  return res.data.data;
};
export const updateBatchGroupColour = async ({ id, payload }) => {
  const res = await API.put(`recipes/${id}/color`, payload);
  return res.data;
};
